import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 10, fill: "#79B851" }), /* @__PURE__ */ React.createElement("path", { d: "M4.6875 9.6875L8.4375 13.4375L15.3125 6.5625", stroke: "white", strokeWidth: 1.67, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
